import search from '@/views/pages/products/category/search/Search.vue';
import { APIRequest } from '@/app/services/APIRequest';
import router from '@/router/index';
import {
  canCreate,
  canView,
  canUpdate,
  canDelete
} from '@/app/services/AuthServices';
import store from '@/app/vuex/store';
/* eslint-disable no-underscore-dangle */
import Navbar from '@/views/components/layouts/Navbar.vue';

export default {
  components: {
    search,
    Navbar
  },
  data: () => ({
    canCreate: canCreate(router.app._route.meta.roles),
    canView: canView(router.app._route.meta.roles),
    canUpdate: canUpdate(router.app._route.meta.roles),
    canDelete: canDelete(router.app._route.meta.roles),
    headers: [
      {
        text: 'รูปภาพ',
        width: '100px',
        align: 'center',
        value: 'cover'
      },
      {
        text: 'ชื่อ',
        width: '300px',
        align: 'start',
        value: 'name'
      },
      {
        text: 'รายละเอียดหมวดหมู่สินค้า',
        width: '300px',
        align: 'start',
        value: 'detail'
      },
      {
        text: 'ดำเนินการ',
        width: '120px',
        align: 'center',
        value: 'action'
      }
    ],
    itemsTableData: [],
    dialogDelete: false,
    idDelete: null
  }),
  watch: {
    '$route.query': function (){
      const queryString = this.$route.query;
      if (queryString.name){
        this.getDataCategoryProductByQuery();
      } else {
        this.getDataCategoryProduct();
      }
    }
  },
  mounted(){
    const queryString = this.$route.query;
    if (queryString.name){
      this.getDataCategoryProductByQuery();
    } else {
      this.getDataCategoryProduct();
    }
  },
  methods: {
    getDataCategoryProduct(){
      store.dispatch('loading/setLoading', true);
      APIRequest({
        method: 'GET',
        url: '/category/list-main',
        auth: true
      }).then(response => {
        store.dispatch('loading/setLoading', false);
        if (response && response.data.code === 10 && response.data.result){
          this.itemsTableData = response.data.result;
        }
      }).catch(error => {
        store.dispatch('loading/setLoading', false);
        console.log(error);
      });
    },

    getDataCategoryProductByQuery(){
      store.dispatch('loading/setLoading', true);
      const data = {
        category: this.$route.query.name
      };
      APIRequest({
        method: 'POST',
        url: '/category/list-by-query-main',
        data,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          this.itemsTableData = response.data.result;
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    },

    viewItem(item){
      this.$router.push({ name: 'ProductCategoryView', query: { type: 'main', id: item._id } });
    },

    editItem(item){
      this.$router.push({ name: 'ProductCategoryEdit', query: { type: 'main', id: item._id } });
    },

    deleteItem(item){
      this.dialogDelete = true;
      // eslint-disable-next-line dot-notation
      this.idDelete = item['_id'];
    },

    confirmDelete(){
      store.dispatch('loading/setLoading', true);
      APIRequest({
        method: 'POST',
        url: '/category/delete',
        data: {
          id: this.idDelete ? this.idDelete : null,
          type: 'main'
        },
        auth: true
      }).then(response => {
        store.dispatch('loading/setLoading', false);
        if (response && response.data.code === 0){
          this.dialogDelete = false;
          const queryString = this.$route.query;
          if (queryString.name){
            this.getDataCategoryProductByQuery();
          } else {
            this.getDataCategoryProduct();
          }
        }
      }).catch(error => {
        this.dialogDelete = false;
        store.dispatch('loading/setLoading', false);
        console.log(error);
      });
    }
  }
};
